import { create } from 'zustand';

interface IToastState {
  message: string;
  color: 'success' | 'danger' | 'warning' | 'primary';
  isOpen: boolean;
  showToast: (message: string, color?: IToastState['color']) => void;
  hideToast: () => void;
}

export const useToast = create<IToastState>((set) => ({
  message: '',
  color: 'primary',
  isOpen: false,
  showToast: (message, color = 'primary') => set({ message, color, isOpen: true }),
  hideToast: () => set({ isOpen: false }),
}));
